import React from 'react';
import { Card } from '../ui/Card';
import { Badge } from '../ui/Badge';
import { ConversionRatio } from '../../types/dashboard';
interface ConversionRatiosProps {
  ratios: ConversionRatio[];
}
export function ConversionRatios({
  ratios
}: ConversionRatiosProps) {
  return <Card title="Funnel Conversion Ratios" className="h-full" data-id="element-38">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-39">
        {ratios.map((ratio, index) => {
        const isLow = ratio.value < ratio.threshold;
        const isZero = ratio.value === 0;
        return <div key={index} className={`p-5 rounded-lg border-2 transition-all ${isLow ? 'border-red-200 bg-red-50/50' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-40">
              <div className="flex justify-between items-start mb-3" data-id="element-41">
                <span className="text-xs font-semibold text-gray-600 uppercase tracking-wide" data-id="element-42">
                  {ratio.label}
                </span>
                {isLow && <Badge variant="danger" size="sm" data-id="element-43">
                    Below Target
                  </Badge>}
              </div>

              <div className="space-y-2" data-id="element-44">
                <div className="flex flex-col gap-1" data-id="element-45">
                  <span className={`text-3xl font-bold tabular-nums ${isLow ? 'text-red-700' : 'text-gray-900'}`} data-id="element-46">
                    {isZero ? 'N/A' : `${ratio.value.toFixed(1)}%`}
                  </span>
                  <span className="text-xs text-gray-500" data-id="element-47">
                    Target: {ratio.threshold}%
                  </span>
                </div>

                {/* Progress bar */}
                {!isZero && <div className="w-full bg-gray-200 rounded-full h-2 mt-3" data-id="element-48">
                    <div className={`h-2 rounded-full transition-all ${isLow ? 'bg-red-500' : 'bg-green-500'}`} style={{
                width: `${Math.min(ratio.value, 100)}%`
              }} data-id="element-49"></div>
                  </div>}
              </div>
            </div>;
      })}
      </div>
    </Card>;
}